import { ArchiveStoryMeta, ArchiveStoryPayload } from 'types/store/ArchiveStory';
import { createAsyncReducer } from 'utils/Redux';

import { archiveStoryActions } from '../actions';

export default createAsyncReducer<ArchiveStoryMeta, ArchiveStoryPayload>(archiveStoryActions);
